<template>
    <div class="footer-wrap">
        <div class="footer-map">
            <div class="wrapCenter">
                <div class="row">
                    <div class="col-sm-8 footer-link">
                        <div class="row">
                            <div class="col-sm-3" v-for="item in mapList">
                                <dl>
                                    <dt> {{ item.title }} </dt>
                                    <dd v-for="child in item.childs" @click="pageSwitch()">
                                        <router-link :to="{path: child.url}"> {{ child.name }} </router-link>
                                    </dd>
                                </dl>
                            </div>
                            <div class="col-sm-3">
                                <dl>
                                    <dt> 关注我们 </dt>
                                    <dd>
                                        <a href="#" data-toggle="modal" data-target="#modalWechat"> 唐麦公众号 </a>
                                    </dd>
                                    <dd>
                                        <a href="http://weibo.com/tangmaikeji" target="_blank"> 唐麦微博 </a>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="footer-link-mobile">
                        <ul>
                            <li v-for="item in mobileMapList"><a :href="item.url"> {{ item.name }} </a></li>
                        </ul>
                    </div>
                    <div class="col-sm-4 footer-contact">
                        <div class="footer-tel">
                            <i class="icon-tel"></i>400-037-0368
                        </div>
                        <div class="footer-time">
                            <p>09:00-20:30 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在线咨询</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="footer-copyright">
            <p>Copyright © 2015 深圳市唐麦科技有限公司.    版权所有 <span class="icp">备案：<a href="https://beian.miit.gov.cn/">粤ICP备15028218号-1</a></span></p>
        </div>

        <!-- 微信公众号 -->
        <div class="modal fade" id="modalWechat" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <img src="../assets/img/wechat.png"  data-dismiss="modal">
            </div>
        </div>
    </div>
    
</template>
<script>
    export default{
        data(){
            return {
                mapList:[
                    // {
                    // title:"服务支持",
                    // childs:[{
                    //     name:"使用说明",
                    //     url: "/server/instructions"
                    // },{
                    //     name:"煲机教程",
                    //     url: "/server/tutorial"
                    // },{
                    //     name:"无损音乐",
                    //     url: "/server/lossless"
                    // },{
                    //     name:"防伪查询",
                    //     url: "/server/security"
                    // }]
                // },{
                //     title:"帮助中心",
                //     childs:[{
                //         name:"支付方式",
                //         url: ""
                //     },{
                //         name:"配送方式",
                //         url: ""
                //     },{
                //         name:"常见问题",
                //         url: ""
                //     }]
                {
                    title:"关于我们",
                    childs:[{
                        name:"品牌文化",
                        url: "/about/culture"
                    // },{
                    //     name:"加入唐麦",
                    //     url: "/about/join"
                    },{
                        name:"联系我们",
                        url: "/about/contact"
                    }]
                // },{
                //     title:"关注我们",
                //     childs:[{
                //         name:"微信公众号",
                //         url: ""
                //     },{
                //         name:"新浪微博",
                //         url: ""
                //     }]
                }],
                mobileMapList:[
                    {
                        name: "天猫店",
                        url: "https://tangmai.tmall.com"
                    },{
                        name: "淘宝店",
                        url: "https://tangmaizhengpin.taobao.com/"
                    },{
                        name: "京东店",
                        url: "http://mall.jd.com/index-149026.html"
                    }
                ]
            }
            
        },
        methods:{
            pageSwitch(){
                this.$emit("pageSwitch");
            }
        }
    }
</script>
<style scoped>
    .footer-wrap{
        background: #000000;
        border-top: 1px #666666 solid;
    }

    .footer-map{
        padding: 60px 0px;
    }
    dl{
        color: #ffffff;
    }

    dl dt{
        font-size: 20px;
        margin-bottom: 10px;
    }

    dl dd{
        line-height: 24px;
    }

    dl dd a{
        color: #ffffff;
    }

    .footer-tel{
        border: 1px #666666 solid;
        border-radius: 15px;
        float: right;
        padding: 2px 20px;
        padding-right: 40px;
        margin-bottom: 10px;
        font-size: 18px;
        color: #ffffff;
    }

    .footer-tel .icon-tel{
        width: 18px;
        height: 18px;
        background: url(../assets/img/icons/tel.png) no-repeat center;
        background-size: contain;
        display: inline-block;
        margin-top: 2px;
        float: left;
        margin-right: 6px;
    }

    .footer-time{
        float: right;
        width: 100%;
        text-align: right;
        color: #ffffff;
        padding-right: 6px;
    }

    .footer-time p{
        float: right;
        border-bottom: 1px #666666 solid;
        padding: 4px 0px;
    }

    .footer-copyright{
        border-top: 1px #666666 solid;
        height: 60px;
    }

    .footer-copyright p{
        text-align: center;
        line-height: 60px;
        color: #ffffff;
    }

    .footer-copyright a{
        color: #ffffff;
    }

    .footer-link-mobile{
        display: none;
    }

    .modal-dialog{
        width: 300px;
        margin: 30px auto;
    }

    #modalWechat img{
        width: 100%;
    }

    @media (max-width: 768px) {
        .footer-wrap{
            float: left;
        width: 100%;
        }
        .footer-link{
            display: none;
        }

        .row{
            margin: 0px;
        }
        .footer-contact{
            overflow: hidden;
            width: 100%;
            padding: 0px;
        }

        .footer-link-mobile{
            display: block;
        }

        .footer-link-mobile ul{
            float: left;
            position: relative;
            left: 50%;
            transform: translate(-50%, 0)
        }

        .footer-link-mobile li{
            float: left;
            padding: 0 0.4rem;
            
            border-right: 1px #666666 solid;
            height: 0.6rem;
        }

        .footer-link-mobile li:last-child{
            border-right: none;
        }

        .footer-link-mobile li a{
            color: #ffffff;
            margin-top: -0.1rem;
            float: left;
            font-size: 0.5rem;
        }

        .footer-map{
            padding: 1.4rem 0;
        }

        .footer-tel{
            float: left;
            position: relative;
            left: 50%;
            transform: translate(-50%);
            margin-top: 1rem;
            font-size: 0.7rem;
        }

        .footer-tel .icon-tel{
            width: 0.7rem;
            height: 0.7rem;
        }

         .footer-time{
             text-align: center;
         }

         .footer-time p{
             float: none;
             border-bottom: none;
             font-size: 0.5rem;
         }

         .footer-copyright{
             font-size: 0.5rem;
             height: auto;
             padding: 10px 0;
         }

         .footer-copyright span{
             display: block;
             font-size: 0.5rem;
         }

         .footer-copyright p{
             line-height: 0.9rem;
             font-size: 0.5rem;
         }

         .modal-dialog{
             width: 12rem;
         }
    }
</style>


// WEBPACK FOOTER //
// src/components/footer.vue